'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = wrapWithErrorMonitoring;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _logError = require('ui-addon-upgrades/_core/common/reliability/logError');

var _logError2 = _interopRequireDefault(_logError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Meant to be used sparingly, as high up as possible.
// `label` is not meant to match the function name. It goes to SFX.

function wrapWithErrorMonitoring(label, func) {
  (0, _invariant2.default)(typeof label === 'string', '[wrapWithErrorMonitoring] argument `label` must be a string, got `%s`', typeof label === 'undefined' ? 'undefined' : _typeof(label));
  (0, _invariant2.default)(typeof func === 'function', '[wrapWithErrorMonitoring] argument `func` must be a function, got `%s`', typeof func === 'undefined' ? 'undefined' : _typeof(func));

  return function monitoredFunc() {
    try {
      return func.apply(undefined, arguments);
    } catch (err) {
      (0, _logError2.default)('ui-addon-upgrades', label);
      throw err;
    }
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/reliability/wrapWithErrorMonitoring.js
// module id = 70
// module chunks = 3 4 5